import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWooComponent } from './simple-icons-woo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWooComponent ],
    exports:      [ SimpleIconsWooComponent ],
    bootstrap:    []
})
export class SimpleIconsWooModule {}
